import type { IconSvgObject } from './types';

const DatabaseZapIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "5", rx: "8", ry: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 15C7.58172 15 4 13.6569 4 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 22C7.58172 22 4 20.6569 4 19V5M20 5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.0801 14L16.7431 16.5528C16.4033 17.2014 16.2335 17.5257 16.387 17.7629C16.5405 18 16.9203 18 17.68 18H18.4802C19.2398 18 19.6196 18 19.7732 18.2371C19.9267 18.4743 19.7568 18.7986 19.4171 19.4472L18.0801 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default DatabaseZapIcon;
